import List from "@/components/list";
import Bus from "./Bus.js";
import Vue from "../../../pages/video/bus";

const Table = args => {
  function deleteVideo(data) {
    Bus.$emit("deleteVideoList", data);
  }
  // 上下线视频
  function onlineVideo(video) {
    Vue.$emit("onlineVideo", { id: [video.uuid], status: video.onlineStatus });
  }
  function upAnddown(data, flag) {
    if (flag) {
      Bus.$emit("upVideoList", data);
    } else return;
  }

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    let dealConf = [
      [
        "icon-delete",
        "删除",
        () => deleteVideo(user.uuid),
        "audioSet:deleteRelation"
      ]
    ];

    if (user.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => onlineVideo(user),
        "audioSet:online"
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => onlineVideo(user),
        "audioSet:online"
      ]);
    }

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Sort = ({ props: { vo } }) => {
    const user = vo.row;
    let Conf = [
      // ["上移", () => upAnddown({ uuid: user.uuid, upAndDown: 0 })],
      // ["下移", () => upAnddown({ uuid: user.uuid, upAndDown: 1 })]
    ];
    if (vo.row.headAndHail == "0") {
      Conf.push([
        "上移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 0 }, false),
        "audioSet:upAndDown",
        "disabled"
      ]);
    } else {
      Conf.push([
        "上移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 0 }, true),
        "audioSet:upAndDown",
        "able"
      ]);
    }
    if (vo.row.headAndHail == "1") {
      Conf.push([
        "下移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 1 }, false),
        "audioSet:upAndDown",
        "disabled"
      ]);
    } else {
      Conf.push([
        "下移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 1 }, true),
        "audioSet:upAndDown",
        "able"
      ]);
    }
    if (vo.row.headAndHail == "01") {
      Conf = [];
      Conf.push([
        "上移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 0 }, false),
        "audioSet:upAndDown",
        "disabled"
      ]);
      Conf.push([
        "下移",
        () => upAnddown({ uuid: user.uuid, upAndDown: 1 }, false),
        "audioSet:upAndDown",
        "disabled"
      ]);
    }
    // if (vo.row.level == 1 && vo.$index !== 0) {
    //   dealConf.unshift(["置顶", () => moveTop(vo, true), "", "able"])
    // } else if (vo.row.level == 1 && vo.$index == 0) {
    //   dealConf.unshift(["置顶", () => moveTop(vo, false), "", "disabled"])
    // }

    return (
      <div class="deal-group">
        {Conf.map(item => (
          <span
            class={item[3] == "disabled" ? "disabled" : "deal-btn"}
            onClick={item[1]}
            v-permission={item[2]}
          >
            {item[0]}
          </span>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "视频名称",
      prop: "videoName"
      // minWidth: "80"
    },
    {
      label: "讲师",
      prop: "lecturerName"
      // minWidth: "100"
    },
    {
      label: "状态",
      prop: "onlineStatusName"
      // minWidth: "80"
    },
    {
      label: "审核状态",
      prop: "videoAuditStatusName"
      // minWidth: "80"
    },
    {
      label: "排序",
      minWidth: "120",
      align: "center",
      render: vo => <Sort vo={vo} />
      // minWidth: "80"
    },
    {
      label: "操作",
      minWidth: "160",
      render: vo => <Deal vo={vo} />
      // minWidth: "80"
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
